<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_GARBAGEKNOWLEDGE',
        formComponent: {
          view: { type: 'component', componentName: 'GarbageKnowledgeView', value: 'queryGarbageTypeDetailData', noRequest: true },
          add: { type: 'component', componentName: 'GarbageKnowledgeEdit', value: 'resetGarbageTypeDetailData' },
          edit: { type: 'component', componentName: 'GarbageKnowledgeEdit', value: 'queryGarbageTypeDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/garbageType/garbageTypeList' },
          delete: { type: 'default', value: '/modules/garbageType/garbageTypeDelete' }
        },
        formInputsData: [{ name: '物品名称', key: 'name', value: '', type: 'text' }],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADD' }],
        formTableData: [
          { name: '垃圾名称', key: 'name', type: 'text' },
          { name: '创建时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '创建人', key: 'createUserName', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
          { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false, permission: 'DELETE' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
          this.$store.dispatch('setGarbageTypeDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    }
  }
}
</script>
